const FONT_RESET = 'FONT_RESET';
const FONT_LIST_PUSH = 'FONT_LIST_PUSH';
const FONT_LIST_UPDATE = 'FONT_LIST_UPDATE';
const HALF_SLIDE_UP_TITLE_FONT = 'HALF_SLIDE_UP_TITLE_FONT';
const HALF_SLIDE_UP_SUBTITLE_FONT = 'HALF_SLIDE_UP_SUBTITLE_FONT';
const HALF_SLIDE_UP_MAIN_BTN_FONT = 'HALF_SLIDE_UP_MAIN_BTN_FONT';
const HALF_SLIDE_UP_LEFT_BTN_FONT = 'HALF_SLIDE_UP_LEFT_BTN_FONT';
const HALF_SLIDE_UP_RIGHT_BTN_FONT = 'HALF_SLIDE_UP_RIGHT_BTN_FONT';
const HALF_SLIDE_UP_IMGS_TITLE_FONT = 'HALF_SLIDE_UP_IMGS_TITLE_FONT';
const HALF_SLIDE_UP_IMGS_SUBTITLE_FONT = 'HALF_SLIDE_UP_IMGS_SUBTITLE_FONT';
const HALF_SLIDE_UP_IMGS_MAIN_BTN_FONT = 'HALF_SLIDE_UP_IMGS_MAIN_BTN_FONT';
const HALF_SLIDE_UP_IMGS_LEFT_BTN_FONT = 'HALF_SLIDE_UP_IMGS_LEFT_BTN_FONT';
const HALF_SLIDE_UP_IMGS_RIGHT_BTN_FONT = 'HALF_SLIDE_UP_IMGS_RIGHT_BTN_FONT';
const FULL_COUNTDOWN_TITLE_FONT = 'FULL_COUNTDOWN_TITLE_FONT';
const FULL_COUNTDOWN_SUBTITLE_FONT = 'FULL_COUNTDOWN_SUBTITLE_FONT';
const FULL_COUNTDOWN_TIME_FONT = 'FULL_COUNTDOWN_TIME_FONT';
const FULL_COUNTDOWN_CLOSING_FONT = 'FULL_COUNTDOWN_CLOSING_FONT';
const FULL_COUNTDOWN_BTN_FONT = 'FULL_COUNTDOWN_BTN_FONT';
const FULL_COUNTDOWN_CLOSE_BTN_FONT = 'FULL_COUNTDOWN_CLOSE_BTN_FONT';
const HALF_TOP_IMAGE_TITLE_FONT = 'HALF_TOP_IMAGE_TITLE_FONT';
const HALF_TOP_IMAGE_SUBTITLE_FONT = 'HALF_TOP_IMAGE_SUBTITLE_FONT';
const HALF_TOP_IMAGE_BTN_FONT = 'HALF_TOP_IMAGE_BTN_FONT';
const HALF_TOP_IMAGE_CLOSE_BTN_FONT = 'HALF_TOP_IMAGE_CLOSE_BTN_FONT';
const MODAL_PAGING_SLIDE_TITLE_FONT = 'MODAL_PAGING_SLIDE_TITLE_FONT';
const MODAL_PAGING_SLIDE_TIME_FONT = 'MODAL_PAGING_SLIDE_TIME_FONT';
const MODAL_PAGING_SLIDE_BTN_FONT = 'MODAL_PAGING_SLIDE_BTN_FONT';
const FULL_DUAL_IMAGE_TITLE_FONT = 'FULL_DUAL_IMAGE_TITLE_FONT';
const FULL_DUAL_IMAGE_SUBTITLE_FONT = 'FULL_DUAL_IMAGE_SUBTITLE_FONT';
const FULL_DUAL_IMAGE_CONTENT1_FONT = 'FULL_DUAL_IMAGE_CONTENT1_FONT';
const FULL_DUAL_IMAGE_CONTENT2_FONT = 'FULL_DUAL_IMAGE_CONTENT2_FONT';
const FULL_DUAL_IMAGE_CONTENT1_BTN_FONT = 'FULL_DUAL_IMAGE_CONTENT1_BTN_FONT';
const FULL_DUAL_IMAGE_CONTENT2_BTN_FONT = 'FULL_DUAL_IMAGE_CONTENT2_BTN_FONT';
const FULL_DUAL_IMAGE_CLOSE_BTN_FONT = 'FULL_DUAL_IMAGE_CLOSE_BTN_FONT';
const MODAL_SLICK_CONTENTS_TITLE_FONT = 'MODAL_SLICK_CONTENTS_TITLE_FONT';
const MODAL_SLICK_CONTENTS_SUBTITLE_FONT = 'MODAL_SLICK_CONTENTS_SUBTITLE_FONT';
const MODAL_SLICK_CONTENTS_BTN_FONT = 'MODAL_SLICK_CONTENTS_BTN_FONT';
const FULL_SURVEY_TITLE_FONT = 'FULL_SURVEY_TITLE_FONT';
const FULL_SURVEY_SUBTITLE_FONT = 'FULL_SURVEY_SUBTITLE_FONT';
const FULL_SURVEY_DEFAULT_CHOICE_FONT = 'FULL_SURVEY_DEFAULT_CHOICE_FONT';
const FULL_SURVEY_ACTIVE_CHOICE_FONT = 'FULL_SURVEY_ACTIVE_CHOICE_FONT';
const FULL_SURVEY_CLOSE_BTN_FONT = 'FULL_SURVEY_CLOSE_BTN_FONT';
const MODAL_SLIDE_IMAGE_LEFT_BTN_FONT = 'MODAL_SLIDE_IMAGE_LEFT_BTN_FONT';
const MODAL_SLIDE_IMAGE_RIGHT_BTN_FONT = 'MODAL_SLIDE_IMAGE_RIGHT_BTN_FONT';
const MODAL_TOP_IMAGE_TITLE_FONT = 'MODAL_TOP_IMAGE_TITLE_FONT';
const MODAL_TOP_IMAGE_LEFT_BTN_FONT = 'MODAL_TOP_IMAGE_LEFT_BTN_FONT';
const MODAL_TOP_IMAGE_RIGHT_BTN_FONT = 'MODAL_TOP_IMAGE_RIGHT_BTN_FONT';
const SINGLE_MODAL_TOP_TITLE_FONT = 'SINGLE_MODAL_TOP_TITLE_FONT';
const SINGLE_MODAL_TOP_LEFT_BTN_FONT = 'SINGLE_MODAL_TOP_LEFT_BTN_FONT';
const SINGLE_MODAL_TOP_RIGHT_BTN_FONT = 'SINGLE_MODAL_TOP_RIGHT_BTN_FONT';

export const fontReset = () => ({ type: FONT_RESET });
export const fontListPush = fontList => ({
  type: FONT_LIST_PUSH,
  fontList
});
export const fontListUpdate = fontList => ({
  type: FONT_LIST_UPDATE,
  fontList
});
export const halfSlideUpTitleFont = halfSlideUpTitleFont => ({
  type: HALF_SLIDE_UP_TITLE_FONT,
  halfSlideUpTitleFont
});
export const halfSlideUpSubTitleFont = halfSlideUpSubTitleFont => ({
  type: HALF_SLIDE_UP_SUBTITLE_FONT,
  halfSlideUpSubTitleFont
});
export const halfSlideUpMainBtnFont = halfSlideUpMainBtnFont => ({
  type: HALF_SLIDE_UP_MAIN_BTN_FONT,
  halfSlideUpMainBtnFont
});
export const halfSlideUpLeftBtnFont = halfSlideUpLeftBtnFont => ({
  type: HALF_SLIDE_UP_LEFT_BTN_FONT,
  halfSlideUpLeftBtnFont
});
export const halfSlideUpRightBtnFont = halfSlideUpRightBtnFont => ({
  type: HALF_SLIDE_UP_RIGHT_BTN_FONT,
  halfSlideUpRightBtnFont
});
export const fullCountdownTitleFont = fullCountdownTitleFont => ({
  type: FULL_COUNTDOWN_TITLE_FONT,
  fullCountdownTitleFont
});
export const fullCountdownSubTitleFont = fullCountdownSubTitleFont => ({
  type: FULL_COUNTDOWN_SUBTITLE_FONT,
  fullCountdownSubTitleFont
});
export const fullCountdownTimeFont = fullCountdownTimeFont => ({
  type: FULL_COUNTDOWN_TIME_FONT,
  fullCountdownTimeFont
});
export const fullCountdownClosingFont = fullCountdownClosingFont => ({
  type: FULL_COUNTDOWN_CLOSING_FONT,
  fullCountdownClosingFont
});
export const fullCountdownBtnFont = fullCountdownBtnFont => ({
  type: FULL_COUNTDOWN_BTN_FONT,
  fullCountdownBtnFont
});
export const fullCountdownCloseBtnFont = fullCountdownCloseBtnFont => ({
  type: FULL_COUNTDOWN_CLOSE_BTN_FONT,
  fullCountdownCloseBtnFont
});
export const halfTopImageTitleFont = halfTopImageTitleFont => ({
  type: HALF_TOP_IMAGE_TITLE_FONT,
  halfTopImageTitleFont
});
export const halfTopImageSubTitleFont = halfTopImageSubTitleFont => ({
  type: HALF_TOP_IMAGE_SUBTITLE_FONT,
  halfTopImageSubTitleFont
});
export const halfTopImageBtnFont = halfTopImageBtnFont => ({
  type: HALF_TOP_IMAGE_BTN_FONT,
  halfTopImageBtnFont
});
export const halfTopImageCloseBtnFont = halfTopImageCloseBtnFont => ({
  type: HALF_TOP_IMAGE_CLOSE_BTN_FONT,
  halfTopImageCloseBtnFont
});
export const modalPagingSlideTitleFont = modalPagingSlideTitleFont => ({
  type: MODAL_PAGING_SLIDE_TITLE_FONT,
  modalPagingSlideTitleFont
});
export const modalPagingSlideTimeFont = modalPagingSlideTimeFont => ({
  type: MODAL_PAGING_SLIDE_TIME_FONT,
  modalPagingSlideTimeFont
});
export const modalPagingSlideBtnFont = modalPagingSlideBtnFont => ({
  type: MODAL_PAGING_SLIDE_BTN_FONT,
  modalPagingSlideBtnFont
});
export const fullDualImageTitleFont = fullDualImageTitleFont => ({
  type: FULL_DUAL_IMAGE_TITLE_FONT,
  fullDualImageTitleFont
});
export const fullDualImageSubTitleFont = fullDualImageSubTitleFont => ({
  type: FULL_DUAL_IMAGE_SUBTITLE_FONT,
  fullDualImageSubTitleFont
});
export const fullDualImageContent1Font = fullDualImageContent1Font => ({
  type: FULL_DUAL_IMAGE_CONTENT1_FONT,
  fullDualImageContent1Font
});
export const fullDualImageContent2Font = fullDualImageContent2Font => ({
  type: FULL_DUAL_IMAGE_CONTENT2_FONT,
  fullDualImageContent2Font
});
export const fullDualImageContent1BtnFont = fullDualImageContent1BtnFont => ({
  type: FULL_DUAL_IMAGE_CONTENT1_BTN_FONT,
  fullDualImageContent1BtnFont
});
export const fullDualImageContent2BtnFont = fullDualImageContent2BtnFont => ({
  type: FULL_DUAL_IMAGE_CONTENT2_BTN_FONT,
  fullDualImageContent2BtnFont
});
export const fullDualImageCloseBtnFont = fullDualImageCloseBtnFont => ({
  type: FULL_DUAL_IMAGE_CLOSE_BTN_FONT,
  fullDualImageCloseBtnFont
});
export const modalSlickContentsTitleFont = modalSlickContentsTitleFont => ({
  type: MODAL_SLICK_CONTENTS_TITLE_FONT,
  modalSlickContentsTitleFont
});
export const modalSlickContentsSubTitleFont = modalSlickContentsSubTitleFont => ({
  type: MODAL_SLICK_CONTENTS_SUBTITLE_FONT,
  modalSlickContentsSubTitleFont
});
export const modalSlickContentsBtnFont = modalSlickContentsBtnFont => ({
  type: MODAL_SLICK_CONTENTS_BTN_FONT,
  modalSlickContentsBtnFont
});
export const fullSurveyTitleFont = fullSurveyTitleFont => ({
  type: FULL_SURVEY_TITLE_FONT,
  fullSurveyTitleFont
});
export const fullSurveySubTitleFont = fullSurveySubTitleFont => ({
  type: FULL_SURVEY_SUBTITLE_FONT,
  fullSurveySubTitleFont
});
export const fullSurveyDefaultChoiceFont = fullSurveyDefaultChoiceFont => ({
  type: FULL_SURVEY_DEFAULT_CHOICE_FONT,
  fullSurveyDefaultChoiceFont
});
export const fullSurveyActiveChoiceFont = fullSurveyActiveChoiceFont => ({
  type: FULL_SURVEY_ACTIVE_CHOICE_FONT,
  fullSurveyActiveChoiceFont
});
export const fullSurveyCloseBtnFont = fullSurveyCloseBtnFont => ({
  type: FULL_SURVEY_CLOSE_BTN_FONT,
  fullSurveyCloseBtnFont
});
export const modalSlideImageLeftBtnFont = modalSlideImageLeftBtnFont => ({
  type: MODAL_SLIDE_IMAGE_LEFT_BTN_FONT,
  modalSlideImageLeftBtnFont
});
export const modalSlideImageRightBtnFont = modalSlideImageRightBtnFont => ({
  type: MODAL_SLIDE_IMAGE_RIGHT_BTN_FONT,
  modalSlideImageRightBtnFont
});
export const modalTopImageTitleFont = modalTopImageTitleFont => ({
  type: MODAL_TOP_IMAGE_TITLE_FONT,
  modalTopImageTitleFont
});
export const modalTopImageLeftBtnFont = modalTopImageLeftBtnFont => ({
  type: MODAL_TOP_IMAGE_LEFT_BTN_FONT,
  modalTopImageLeftBtnFont
});
export const modalTopImageRightBtnFont = modalTopImageRightBtnFont => ({
  type: MODAL_TOP_IMAGE_RIGHT_BTN_FONT,
  modalTopImageRightBtnFont
});
export const singleModalTopTitleFont = singleModalTopTitleFont => ({
  type: SINGLE_MODAL_TOP_TITLE_FONT,
  singleModalTopTitleFont
});
export const singleModalTopLeftBtnFont = singleModalTopLeftBtnFont => ({
  type: SINGLE_MODAL_TOP_LEFT_BTN_FONT,
  singleModalTopLeftBtnFont
});
export const singleModalTopRightBtnFont = singleModalTopRightBtnFont => ({
  type: SINGLE_MODAL_TOP_RIGHT_BTN_FONT,
  singleModalTopRightBtnFont
});
export const halfSlideUpImgsTitleFont = halfSlideUpImgsTitleFont => ({
  type: HALF_SLIDE_UP_IMGS_TITLE_FONT,
  halfSlideUpImgsTitleFont
});
export const halfSlideUpImgsSubTitleFont = halfSlideUpImgsSubTitleFont => ({
  type: HALF_SLIDE_UP_IMGS_SUBTITLE_FONT,
  halfSlideUpImgsSubTitleFont
});
export const halfSlideUpImgsMainBtnFont = halfSlideUpImgsMainBtnFont => ({
  type: HALF_SLIDE_UP_IMGS_MAIN_BTN_FONT,
  halfSlideUpImgsMainBtnFont
});
export const halfSlideUpImgsLeftBtnFont = halfSlideUpImgsLeftBtnFont => ({
  type: HALF_SLIDE_UP_IMGS_LEFT_BTN_FONT,
  halfSlideUpImgsLeftBtnFont
});
export const halfSlideUpImgsRightBtnFont = halfSlideUpImgsRightBtnFont => ({
  type: HALF_SLIDE_UP_IMGS_RIGHT_BTN_FONT,
  halfSlideUpImgsRightBtnFont
});

const initialState = {
  fontList: [],
  halfSlideUpTitleFont: '',
  halfSlideUpSubTitleFont: '',
  halfSlideUpMainBtnFont: '',
  halfSlideUpLeftBtnFont: '',
  halfSlideUpRightBtnFont: '',
  fullCountdownTitleFont: '',
  fullCountdownSubTitleFont: '',
  fullCountdownTimeFont: '',
  fullCountdownClosingFont: '',
  fullCountdownBtnFont: '',
  fullCountdownCloseBtnFont: '',
  halfTopImageTitleFont: '',
  halfTopImageSubTitleFont: '',
  halfTopImageBtnFont: '',
  halfTopImageCloseBtnFont: '',
  modalPagingSlideTitleFont: '',
  modalPagingSlideTimeFont: '',
  modalPagingSlideBtnFont: '',
  fullDualImageTitleFont: '',
  fullDualImageSubTitleFont: '',
  fullDualImageContent1Font: '',
  fullDualImageContent2Font: '',
  fullDualImageContent1BtnFont: '',
  fullDualImageContent2BtnFont: '',
  fullDualImageCloseBtnFont: '',
  modalSlickContentsTitleFont: '',
  modalSlickContentsSubTitleFont: '',
  modalSlickContentsBtnFont: '',
  fullSurveyTitleFont: '',
  fullSurveySubTitleFont: '',
  fullSurveyDefaultChoiceFont: '',
  fullSurveyActiveChoiceFont: '',
  fullSurveyCloseBtnFont: '',
  modalSlideImageLeftBtnFont: '',
  modalSlideImageRightBtnFont: '',
  modalTopImageTitleFont: '',
  modalTopImageLeftBtnFont: '',
  modalTopImageRightBtnFont: '',
  singleModalTopTitleFont: '',
  singleModalTopLeftBtnFont: '',
  singleModalTopRightBtnFont: '',
  halfSlideUpImgsTitleFont: '',
  halfSlideUpImgsSubTitleFont: '',
  halfSlideUpImgsMainBtnFont: '',
  halfSlideUpImgsLeftBtnFont: '',
  halfSlideUpImgsRightBtnFont: ''
};

export default function fontReducer(state = initialState, action) {
  switch (action.type) {
    case FONT_RESET:
      return initialState;
    case FONT_LIST_PUSH:
      return {
        ...state,
        fontList: [...state.fontList, action.fontList]
      };
    case FONT_LIST_UPDATE:
      return {
        ...state,
        fontList: action.fontList
      };
    case HALF_SLIDE_UP_TITLE_FONT:
      return {
        ...state,
        halfSlideUpTitleFont: action.halfSlideUpTitleFont
      };
    case HALF_SLIDE_UP_SUBTITLE_FONT:
      return {
        ...state,
        halfSlideUpSubTitleFont: action.halfSlideUpSubTitleFont
      };
    case HALF_SLIDE_UP_MAIN_BTN_FONT:
      return {
        ...state,
        halfSlideUpMainBtnFont: action.halfSlideUpMainBtnFont
      };
    case HALF_SLIDE_UP_LEFT_BTN_FONT:
      return {
        ...state,
        halfSlideUpLeftBtnFont: action.halfSlideUpLeftBtnFont
      };
    case HALF_SLIDE_UP_RIGHT_BTN_FONT:
      return {
        ...state,
        halfSlideUpRightBtnFont: action.halfSlideUpRightBtnFont
      };
    case FULL_COUNTDOWN_TITLE_FONT:
      return {
        ...state,
        fullCountdownTitleFont: action.fullCountdownTitleFont
      };
    case FULL_COUNTDOWN_SUBTITLE_FONT:
      return {
        ...state,
        fullCountdownSubTitleFont: action.fullCountdownSubTitleFont
      };
    case FULL_COUNTDOWN_TIME_FONT:
      return {
        ...state,
        fullCountdownTimeFont: action.fullCountdownTimeFont
      };
    case FULL_COUNTDOWN_CLOSING_FONT:
      return {
        ...state,
        fullCountdownClosingFont: action.fullCountdownClosingFont
      };
    case FULL_COUNTDOWN_BTN_FONT:
      return {
        ...state,
        fullCountdownBtnFont: action.fullCountdownBtnFont
      };
    case FULL_COUNTDOWN_CLOSE_BTN_FONT:
      return {
        ...state,
        fullCountdownCloseBtnFont: action.fullCountdownCloseBtnFont
      };
    case HALF_TOP_IMAGE_TITLE_FONT:
      return {
        ...state,
        halfTopImageTitleFont: action.halfTopImageTitleFont
      };
    case HALF_TOP_IMAGE_SUBTITLE_FONT:
      return {
        ...state,
        halfTopImageSubTitleFont: action.halfTopImageSubTitleFont
      };
    case HALF_TOP_IMAGE_BTN_FONT:
      return {
        ...state,
        halfTopImageBtnFont: action.halfTopImageBtnFont
      };
    case HALF_TOP_IMAGE_CLOSE_BTN_FONT:
      return {
        ...state,
        halfTopImageCloseBtnFont: action.halfTopImageCloseBtnFont
      };
    case MODAL_PAGING_SLIDE_TITLE_FONT:
      return {
        ...state,
        modalPagingSlideTitleFont: action.modalPagingSlideTitleFont
      };
    case MODAL_PAGING_SLIDE_TIME_FONT:
      return {
        ...state,
        modalPagingSlideTimeFont: action.modalPagingSlideTimeFont
      };
    case MODAL_PAGING_SLIDE_BTN_FONT:
      return {
        ...state,
        modalPagingSlideBtnFont: action.modalPagingSlideBtnFont
      };
    case FULL_DUAL_IMAGE_TITLE_FONT:
      return {
        ...state,
        fullDualImageTitleFont: action.fullDualImageTitleFont
      };
    case FULL_DUAL_IMAGE_SUBTITLE_FONT:
      return {
        ...state,
        fullDualImageSubTitleFont: action.fullDualImageSubTitleFont
      };
    case FULL_DUAL_IMAGE_CONTENT1_FONT:
      return {
        ...state,
        fullDualImageContent1Font: action.fullDualImageContent1Font
      };
    case FULL_DUAL_IMAGE_CONTENT2_FONT:
      return {
        ...state,
        fullDualImageContent2Font: action.fullDualImageContent2Font
      };
    case FULL_DUAL_IMAGE_CONTENT1_BTN_FONT:
      return {
        ...state,
        fullDualImageContent1BtnFont: action.fullDualImageContent1BtnFont
      };
    case FULL_DUAL_IMAGE_CONTENT2_BTN_FONT:
      return {
        ...state,
        fullDualImageContent2BtnFont: action.fullDualImageContent2BtnFont
      };
    case FULL_DUAL_IMAGE_CLOSE_BTN_FONT:
      return {
        ...state,
        fullDualImageCloseBtnFont: action.fullDualImageCloseBtnFont
      };
    case MODAL_SLICK_CONTENTS_TITLE_FONT:
      return {
        ...state,
        modalSlickContentsTitleFont: action.modalSlickContentsTitleFont
      };
    case MODAL_SLICK_CONTENTS_SUBTITLE_FONT:
      return {
        ...state,
        modalSlickContentsSubTitleFont: action.modalSlickContentsSubTitleFont
      };
    case MODAL_SLICK_CONTENTS_BTN_FONT:
      return {
        ...state,
        modalSlickContentsBtnFont: action.modalSlickContentsBtnFont
      };
    case FULL_SURVEY_TITLE_FONT:
      return {
        ...state,
        fullSurveyTitleFont: action.fullSurveyTitleFont
      };
    case FULL_SURVEY_SUBTITLE_FONT:
      return {
        ...state,
        fullSurveySubTitleFont: action.fullSurveySubTitleFont
      };
    case FULL_SURVEY_DEFAULT_CHOICE_FONT:
      return {
        ...state,
        fullSurveyDefaultChoiceFont: action.fullSurveyDefaultChoiceFont
      };
    case FULL_SURVEY_ACTIVE_CHOICE_FONT:
      return {
        ...state,
        fullSurveyActiveChoiceFont: action.fullSurveyActiveChoiceFont
      };
    case FULL_SURVEY_CLOSE_BTN_FONT:
      return {
        ...state,
        fullSurveyCloseBtnFont: action.fullSurveyCloseBtnFont
      };
    case MODAL_SLIDE_IMAGE_LEFT_BTN_FONT:
      return {
        ...state,
        modalSlideImageLeftBtnFont: action.modalSlideImageLeftBtnFont
      };
    case MODAL_SLIDE_IMAGE_RIGHT_BTN_FONT:
      return {
        ...state,
        modalSlideImageRightBtnFont: action.modalSlideImageRightBtnFont
      };
    case MODAL_TOP_IMAGE_TITLE_FONT:
      return {
        ...state,
        modalTopImageTitleFont: action.modalTopImageTitleFont
      };
    case MODAL_TOP_IMAGE_LEFT_BTN_FONT:
      return {
        ...state,
        modalTopImageLeftBtnFont: action.modalTopImageLeftBtnFont
      };
    case MODAL_TOP_IMAGE_RIGHT_BTN_FONT:
      return {
        ...state,
        modalTopImageRightBtnFont: action.modalTopImageRightBtnFont
      };
    case SINGLE_MODAL_TOP_TITLE_FONT:
      return {
        ...state,
        singleModalTopTitleFont: action.singleModalTopTitleFont
      };
    case SINGLE_MODAL_TOP_LEFT_BTN_FONT:
      return {
        ...state,
        singleModalTopLeftBtnFont: action.singleModalTopLeftBtnFont
      };
    case SINGLE_MODAL_TOP_RIGHT_BTN_FONT:
      return {
        ...state,
        singleModalTopRightBtnFont: action.singleModalTopRightBtnFont
      };
    case HALF_SLIDE_UP_IMGS_TITLE_FONT:
      return {
        ...state,
        halfSlideUpImgsTitleFont: action.halfSlideUpImgsTitleFont
      };
    case HALF_SLIDE_UP_IMGS_SUBTITLE_FONT:
      return {
        ...state,
        halfSlideUpImgsSubTitleFont: action.halfSlideUpImgsSubTitleFont
      };
    case HALF_SLIDE_UP_IMGS_MAIN_BTN_FONT:
      return {
        ...state,
        halfSlideUpImgsMainBtnFont: action.halfSlideUpImgsMainBtnFont
      };
    case HALF_SLIDE_UP_IMGS_LEFT_BTN_FONT:
      return {
        ...state,
        halfSlideUpImgsLeftBtnFont: action.halfSlideUpImgsLeftBtnFont
      };
    case HALF_SLIDE_UP_IMGS_RIGHT_BTN_FONT:
      return {
        ...state,
        halfSlideUpImgsRightBtnFont: action.halfSlideUpImgsRightBtnFont
      };
    default:
      return state;
  }
}
